import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface FormFieldProps {
  id: string;
  label: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  description?: string;
}

export function FormField({ id, label, error, required, children, description }: FormFieldProps) {
  return (
    <div className="space-y-1.5">
      <Label
        htmlFor={id}
        className={cn(
          "text-sm font-medium",
          error ? "text-red-600" : "text-textBody"
        )}
      >
        {label}
        {required && <span className="text-rose ml-1" aria-hidden="true">*</span>}
      </Label>
      {children}
      {description && !error && (
        <p id={`${id}-description`} className="text-xs text-textMuted">
          {description}
        </p>
      )}
      {error && (
        <p id={`${id}-error`} className="text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
